export default "__VITE_ASSET__CsrZKwqf__"